import RequestHandler from "./RequestHandler";

function UsersAPI() {
    const baseUsersAPI = "users";

    async function getUsers(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "firstname";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseUsersAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getUser(id) {
        try {
            const result = await RequestHandler.get(`${baseUsersAPI}/${id}`);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function resetUserPassword(id) {
        try {
            const result = await RequestHandler.get(
                `${baseUsersAPI}/credentials/reset/${id}`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getUserWithoutId() {
        try {
            const result = await RequestHandler.get(baseUsersAPI);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function addNewUser(newUser) {
        try {
            const result = await RequestHandler.post(baseUsersAPI, newUser);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function updateUser(editUser) {
        try {
            const result = await RequestHandler.put(baseUsersAPI, editUser);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteUser(id) {
        try {
            const result = await RequestHandler.remove(`${baseUsersAPI}/${id}`);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function changeUserPassword(passwordData) {
        try {
            const result = await RequestHandler.post(
                `${baseUsersAPI}/credentials`,
                passwordData
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function changeRecoveryQuestion(questionData) {
        try {
            const result = await RequestHandler.post(
                `${baseUsersAPI}/credentials/question`,
                questionData
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getUserByEmail(email) {
        try {
            const result = await RequestHandler.get(
                `${baseUsersAPI}/user-by-email/${email}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getIsUserLocked(userId) {
        try {
            const result = await RequestHandler.get(
                `${baseUsersAPI}/locked/${userId}`
            );
            return result || "";
        } catch (error) {
            console.log(error);
        }
    }

    async function unlockUser(userId) {
        try {
            const result = await RequestHandler.put(
                `${baseUsersAPI}/unlock/${userId}`
            );
            return result || "";
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getUsers,
        getUser,
        addNewUser,
        deleteUser,
        updateUser,
        getUserWithoutId,
        resetUserPassword,
        changeUserPassword,
        changeRecoveryQuestion,
        getUserByEmail,
        getIsUserLocked,
        unlockUser,
    };
}

export default UsersAPI();
